<template>
  <!--html do computador-->
  <div class="hidden-sm hidden-xs">

    <!--=== MENU ==================-->
    <header>
      <div class="header-area">
        <div v-if="topoMenu != ''" class="main-header ">

          <!-- barra topo telefone e redes sociais -->
          <div class="header-top d-none d-sm-block">
            <div class="container">
              <div class="row">
                <div class="col-xl-12">
                  <div class="d-flex justify-content-between flex-wrap align-items-center">
                    <div class="header-info-left">
                      <ul>
                        <li>{{ topoMenu[0].itiCampoExtra3 }} {{ topoMenu[0].itiCampoExtra4 }}</li>
                        <li>{{ topoMenu[0].itiCampoExtra2 }}</li>
                        <li>{{ topoMenu[0].itiCampoExtra5 }} {{ topoMenu[0].itiCampoExtra6 }}</li>
                      </ul>
                    </div>
                    <div class="header-info-right d-none d-md-block">
                      <ul v-if="redesSociais && redesSociais.length > 0" class="header-social">
                        <li v-if="redesSociais[0].itiCampoExtra1 !== '0'"><a :href="redesSociais[0].itiCampoExtra1"
                            target="_blank"><i class="fab fa-facebook"></i></a>
                        </li>
                        <li v-if="redesSociais[0].itiCampoExtra2 !== '0'"><a :href="redesSociais[0].itiCampoExtra2"
                            target="_blank"><i class="fab fa-linkedin-in"></i></a>
                        </li>
                        <li v-if="redesSociais[0].itiNome !== '0'"><a :href="redesSociais[0].itiNome" target="_blank"><i
                              class="fab fa-youtube"></i></a>
                        </li>
                        <li v-if="redesSociais[0].itiReferencia !== '0'"><a :href="redesSociais[0].itiReferencia"
                            target="_blank"><i class="fab fa-instagram"></i></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- barra logo e menu -->
          <div class="header-bottom  header-sticky">
            <div class="container">
              <div class="row align-items-center">
                <!-- Logo -->
                <div class="col-xl-2 col-lg-2">
                  <div class="logo">
                    <router-link to="/"><img :src="$imagens + 'logo.png'" alt=""></router-link>
                  </div>
                </div>
                <div class="col-xl-10 col-lg-10">
                  <!-- Main-menu -->
                  <div class="main-menu f-right d-none d-lg-block">
                    <nav>
                      <ul id="navigation">
                        <li><router-link to="/">Home</router-link></li>
                        <li><a href="#">Produtos</a>
                          <ul v-if="listaProdutos != '' && listaProdutos.length > 0" class="submenu">
                            <li v-for="menu in listaProdutos" :key="menu.itiId">
                              <router-link class="dropdown-item"
                                :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome)">{{ menu.itiNome
                                }}</router-link>
                            </li>
                          </ul>
                        </li>
                        <li><router-link to="/sobre">Sobre a Empresa</router-link></li>
                        <li><router-link to="/blog">Notícias</router-link></li>
                        <li><router-link to="/contato">Contato</router-link></li>
                        <li>
                          <div class="header-right-btn f-right ml-15">
                            <a :href="topoMenu[0].itiReferencia" class="header-btn" target="_blank"
                              rel="noopener noreferrer">
                              <i class="fab fa-whatsapp"></i> {{ topoMenu[0].itiNome }}
                            </a>
                          </div>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <!-- Mobile Menu -->
                <div class="col-12">
                  <div class="mobile_menu d-block d-lg-none"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

  </div>

  <!--html do celular-->
  <div class="container hidden-lg hidden-md" style="position:absolute; z-index: 3; background-color: #fff;">
    <div class="row celular-alinhado">
      <div class="col-3">
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-dots-vertical" v-bind="props"></v-btn>
          </template>
          <v-list class="celular-topo">
            <v-list-item><router-link to="/"><v-list-item-title
                  class=" menu">Home</v-list-item-title></router-link></v-list-item>

            <v-list-item v-for="menu in listaProdutos" :key="menu.itiId"><router-link
                :to="'/ProdutosDetalhe/' + menu.itiId + '/' + formataLink(menu.itiNome + menu.itiReferencia)"><v-list-item-title
                  class=" menu" style="font-weight: 600;">{{ menu.itiNome
                  }}</v-list-item-title></router-link></v-list-item>

            <v-list-item><router-link to="/sobre"><v-list-item-title class=" menu">Sobre a
                  Empresa</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/blog"><v-list-item-title
                  class=" menu">Notícias</v-list-item-title></router-link></v-list-item>
            <v-list-item><router-link to="/contato"><v-list-item-title
                  class=" menu">Contato</v-list-item-title></router-link></v-list-item>

            <!--=== INFORMAAÇÕES GERAIS ===-->
            <v-list-item v-for="menuInfo in informacoes" :key="menuInfo.itiId">
              <router-link
                :to="'/informacoes/' + menuInfo.itiId + '/' + menuInfo.itiNome.replaceAll(' ', '-').replaceAll('/', '').replaceAll(',', '')">
                <v-list-item-title class=" menu"><em>{{ menuInfo.itiNome }}</em></v-list-item-title></router-link>
            </v-list-item>

          </v-list>
        </v-menu>
      </div>
      <div class="col-9">
        <router-link to="/"><img :src="$imagens + 'logo.png'" alt=""></router-link>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageHeader',

  components: {

  },

  data: () => ({
    topoMenu: [],
    listaProdutos: [],
    redesSociais: [],
    informacoes: [],
    showModernizacaoMenu: false,
    isMenuOpen: false,
    abre: false,
  }),

  methods: {
    toggleModernizacaoMenu() {
      this.showModernizacaoMenu = !this.showModernizacaoMenu;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },

  created() {
    // TOPO MENU
    axios.get('/Process/InsInstitucional/institucional/9/whatsapp/0/x')
      .then(response => {
        this.topoMenu = response.data;
        //console.log('topoMenu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

    // LISTA PRODUTOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaProdutos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaProdutos')
        //console.log(this.listaProdutos)
      })
      .catch(error => {
        console.error(error);
      });

    // REDES SOCIAIS
    axios.get('/Process/InsInstitucional/institucional/55/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('redesSociais', this.redesSociais);
      })
      .catch(error => {
        console.error(error);
      });

    // INFORMAÇÕES GERAIS
    axios.get('/Process/InsInstitucional/institucional/54/listadasinformacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('informacoes')
        //console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });

  }
};
</script>

<style scoped>
.menu {
  line-height: 1.2;
  /* padrão costuma ser 1.5 */
  font-size: 16px;
  font-weight: 400;
  transition: color 0.3s;
  padding: 4px 0;
  /* opcional: controla o espaçamento vertical */
}

.menu:hover {
  color: #0047AB;
  /* muda cor ao passar o mouse */
}

.celular-topo {
  padding: 0;
  margin: 0;
  background-color: #FFF;
  /* cor de fundo opcional */
  margin-top: 10px;
}

/* reduz altura e espaçamento dos itens */
.celular-topo .v-list-item {
  min-height: 36px;
  /* padrão é 48px */
  padding-top: 6px;
  padding-bottom: 6px;
}

/* estilização dos textos */
.celular-topo .menu {
  font-size: 15px;
  font-weight: 400;
  color: #0047AB;
  line-height: 1.2;
  /* diminui entrelinha */
  transition: color 0.3s ease;
}

/* efeito hover */
.celular-topo .menu:hover {
  color: #FF7E1C;
  /* cor ao passar o mouse */
}

/* botão whatsapp / orçamento */
.celular-topo .header-btn .menu {
  font-weight: 600;
  color: #0047AB;
}

/* opcional: centraliza ícone e texto */
.celular-topo .header-btn i {
  margin-right: 6px;
  font-size: 16px;
  vertical-align: middle;
}

/* remove sublinhado do router-link */
.celular-topo a {
  text-decoration: none;
}

.celular-alinhado {
  display: flex;
  justify-content: space-between;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: center;
}
</style>
